// Encryption Utility
// SECURITY WARNING: This utility should be moved to backend for production use

import CryptoJS from 'crypto-js';

// Get encryption key from environment variables
const getEncryptionKey = () => {
  const key = process.env.REACT_APP_ENCRYPTION_KEY;
  
  if (!key) {
    // console.error('🚨 SECURITY ERROR: Encryption key not found in environment variables!');
    throw new Error('Encryption key not configured');
  }
  
  if (process.env.NODE_ENV === 'development') {
    // console.warn('⚠️  SECURITY WARNING: Client-side encryption is not secure for production!');
    // console.warn('⚠️  Move encryption logic to backend immediately!');
  }
  
  return key;
};

export const encryptData = (data) => {
  try {
    const secretKey = getEncryptionKey();
    const jsonData = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(jsonData, secretKey).toString();
    return encryptedData;
  } catch (error) {
    // console.error('Encryption failed:', error);
    throw new Error('Failed to encrypt data');
  }
};

export const decryptData = (encryptedData) => {
  try {
    const secretKey = getEncryptionKey();
    
    if (!encryptedData) {
      return null;
    }
    
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    // console.error('Decryption failed:', error);
    return null;
  }
};

// Legacy functions for backward compatibility
export const encryptAndStoreData = (data) => {
  const encryptedData = encryptData(data);
  localStorage.setItem("encryptedGData", encryptedData);
  return encryptedData;
};

export const decryptAndRetrieveData = (data) => {
  return decryptData(data);
};

